import { INIT_SIMPLIFIED_BANKROLL } from "../constants";
import {
  normalizeRegistros,
  normalizeSimplifiedBankroll,
  normalizeTournaments,
} from "./dataModel";
import { cloneCompletePreferences } from "./supabaseMapping";

const appDataCache = new Map();
const appDataRequests = new Map();

export const cloneAppData = (data) => ({
  tournaments: normalizeTournaments(data?.tournaments || []),
  commonTournaments: normalizeTournaments(data?.commonTournaments || []),
  registros: normalizeRegistros(data?.registros || []),
  completePreferences: cloneCompletePreferences(data?.completePreferences),
  simplifiedBankroll: normalizeSimplifiedBankroll(
    data?.simplifiedBankroll || INIT_SIMPLIFIED_BANKROLL
  ),
});

export const getCachedAppData = (userId) => {
  const cached = appDataCache.get(userId);
  return cached ? cloneAppData(cached.data) : null;
};

export const setCachedAppData = (userId, data) => {
  if (!userId) return;
  appDataCache.set(userId, {
    data: cloneAppData(data),
    updatedAt: Date.now(),
  });
};

export const updateCachedAppData = (userId, updater) => {
  if (!userId) return;
  const current = getCachedAppData(userId);
  if (!current) return;
  setCachedAppData(userId, updater(current));
};

export const getPendingAppDataRequest = (userId) => appDataRequests.get(userId);

export const setPendingAppDataRequest = (userId, request) => {
  appDataRequests.set(userId, request);
};

export const clearPendingAppDataRequest = (userId) => {
  appDataRequests.delete(userId);
};

export const clearAppDataCache = (userId) => {
  if (userId) {
    appDataCache.delete(userId);
    appDataRequests.delete(userId);
    return;
  }
  appDataCache.clear();
  appDataRequests.clear();
};
